(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-collections-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cc-collections-carousel')) {
  customElements.define('cc-collections-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;

      const track = this.querySelector('.ccc__collection-track');
      if (!track) return;

      const cards = Array.from(track.children);
      const controls = this.querySelector('.ccc__carousel-controls');
      if (!controls || !cards.length) return;

      const buttons = Array.from(controls.querySelectorAll('button'));
      const count = controls.querySelector('.ccc__carousel-count');

      const reduced = () =>
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const position = card =>
        card.getBoundingClientRect().left -
        track.getBoundingClientRect().left +
        track.scrollLeft;

      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);

        buttons[0].disabled = track.scrollLeft <= 2;
        buttons[1].disabled = track.scrollLeft >= max - 2;

        let nearest = 0;

        cards.forEach((card, i) => {
          if (
            Math.abs(position(card) - track.scrollLeft) <
            Math.abs(position(cards[nearest]) - track.scrollLeft)
          ) {
            nearest = i;
          }
        });

        count.textContent = (nearest + 1) + ' / ' + cards.length;
      };

      const click = event => {
        const button = event.target.closest('button[data-direction]');
        if (!button || button.disabled) return;

        const step = cards.length > 1
          ? position(cards[1]) - position(cards[0])
          : track.clientWidth;

        track.scrollBy({
          left: Number(button.dataset.direction) * step,
          behavior: reduced() ? 'auto' : 'smooth'
        });
      };

      const select = event => {
        const card = event.target.closest('.ccc__collection-item');

        if (card && track.contains(card)) {
          track.scrollTo({
            left: position(card),
            behavior: 'auto'
          });
        }
      };

      controls.hidden = false;
      controls.addEventListener('click', click);
      track.addEventListener('scroll', update, { passive: true });
      this.addEventListener('shopify:block:select', select);
      window.addEventListener('resize', update);

      const observer = typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(update)
        : null;

      if (observer) observer.observe(track);

      update();

      this.cleanup = () => {
        controls.removeEventListener('click', click);
        track.removeEventListener('scroll', update);
        this.removeEventListener('shopify:block:select', select);
        window.removeEventListener('resize', update);
        if (observer) observer.disconnect();
      };
    }

    disconnectedCallback() {
      if (this.cleanup) {
        this.cleanup();
        this.cleanup = null;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
